var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container",attrs:{"data-testid":_vm.$testIds.app.loader}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cssload-thecube"},[_c('div',{staticClass:"cssload-cube cssload-c1"}),_c('div',{staticClass:"cssload-cube cssload-c2"}),_c('div',{staticClass:"cssload-cube cssload-c4"}),_c('div',{staticClass:"cssload-cube cssload-c3"})])
}]

export { render, staticRenderFns }